// libs/core/src/lib/random/random.ts
var genRandomHex = (size) => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join("");
export {
  genRandomHex
};
//# sourceMappingURL=index.esm.js.map
